import { executeQuery } from '../queries/useUQL';
import { getAbsoluteTimeRange, logger } from '../../utils';

type UqlProps = {
  since: string;
  until: string | undefined;
  queryStr: string;
};

export const uql = ({ since, until, queryStr }: UqlProps): any => {
  logger.log('uql', { since, until, queryStr });
  const absoluteTimeRange = getAbsoluteTimeRange(since, until);
  const queryParts = [
    since ? `SINCE ${absoluteTimeRange.since}` : '',
    until ? `UNTIL ${absoluteTimeRange.until}` : '',
    queryStr,
  ];
  return executeQuery(queryParts.filter(Boolean).join(' '));
};
